import { createFetch } from '@vueuse/core'

export default function createFetchInstance(baseUrl: string, token: string) {
  const useMyFetch = createFetch({
    baseUrl,
    options: {
      async beforeFetch({ options }) {
        const headers = (options.headers as Record<string, string>) || {}

        if (!headers.Authorization)
          headers.Authorization = `Bearer ${token}`

        options.headers = { ...headers }
        return { options }
      },
    },
    fetchOptions: {
      mode: 'cors',
    },
  })

  return useMyFetch
}
